import { render, staticRenderFns } from "./PlanManage.vue?vue&type=template&id=503e47f7&"
import script from "./PlanManage.vue?vue&type=script&lang=js&"
export * from "./PlanManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports